import React from 'react'
import { Route, Redirect } from 'react-router-dom'

import { authService } from '../../base/services'

const EmptyLayout = (props) => {
  if (!authService.isAuthenticated()) {
    const isRedirectToLoginPage =
      props.requireLogin && window.location.pathname !== '/sign-in'
    if (isRedirectToLoginPage)
      if (document.location.href.includes('sign-out')) {
        return <Redirect to={`/sign-in`} />
      } else {
        return <Redirect to={`/sign-in?url=${document.location.href}`} />
      }
  }

  const { component: ComponentPage, ...rest } = props
  return (
    <div className="wapper-container">
      <div className="main-content">
        <Route
          {...rest}
          render={routeProps => (
            <ComponentPage {...routeProps} />
          )}
        />
      </div>
    </div>
  )
}

export default EmptyLayout
